module.exports = __webpack_public_path__ + "media/img/pages/profile/vaudoise ger 6-32590cf8367c1b349a4a0c69bd6f5fae.jpg";